export const STRING_FULL_WIDTH_LIMIT = 17;
export const STRING_NAME_CATEGORY_FULL_WIDTH_LIMIT = 20;
export const STRING_LIMIT = 18;
export const STRING_LIMIT_END_CHAR = '...';
export const FILTER_BY_TAGS = 'tags';
export const TEXT_CHAT_LINE_LIMIT = 50;
export const MAX_HIGHT_MESSAGE = 20000;
export const ANIMATE_TIME_LOAD_MESSAGE = 100;
export const TIME_LOAD_MIN = 1;
export const TIME_LOAD_MESSAGE = 2000;
export const TIME_LOAD_DATA_SEARCH = 2000;
export const TIME_LOADING = 1000;
export const TIME_UPDATE_SCROLL = 200;
export const SHORT_STUDENT_TAGS_NUMBER = 15;
export const TEXT_MESSAGE_MAX = 2000;
export const TEXT_MESSAGE_MIN = 0;
export const MIN_SCROLLBAR_LENGTH = 40;
export const TIME_FORMAT = 12;
export const DATE_MONTH_FORMAT = 10;
export const MAX_TAG_LENGTH = 500;
export const MAX_TEXT_NAME_FOLDER = 20;
export const MAX_TEXT_NAME_FLOW = 20;
export const MAX_TEXT_NAME_INIT_FLOW = 12;
export const MAX_TEXT_NAME_TEMPLATE = 7;
export const MAX_TEXT_TEMPLATE_CONTENT = 7;
export const MAX_TEXT_CONTENT_BROADCAST_MAIL = 24;
export const START_LINE_1_TEMPLATE_CONTENT = 0;
export const END_LINE_1_TEMPLATE_CONTENT = 24;
export const START_LINE_2_TEMPLATE_CONTENT = 25;
export const END_LINE_2_TEMPLATE_CONTENT = 48;
export const LIMIT_SHORT_TAG_CHARACTER = 18;
export const LIMIT_TAG_CHARACTER = 30;
export const TYPE_MESSAGE_REPLY_TEXT = 'text';
export const TYPE_MESSAGE_REPLY_URL = 'url';
export const TYPE_MESSAGE_REPLY_TEMPLATE = 'template';
export const TYPE_MESSAGE_REPLY_SCENARIO = 'scenario';
export const STUDENT_COLUMN_NAME = 'name';
export const STUDENT_COLUMN_ID = 'id';
export const STUDENT_COLUMN_LINE_ID = 'line_id';
export const STUDENT_COLUMN_NICKNAME = 'nickname';
export const _1MB = 1024 * 1024;
export const _10MB = 1024 * 1024 * 10;
export const MAX_IMAGE_SIZE = _1MB;
export const MAX_IMAGE_WIDTH = 1024;
export const MIN_IMAGE_WIDTH = 300;
export const MAX_PRIVATE_LINE_TALK_IMAGE_SIZE = _10MB;
export const MAX_CALENDAR_IMAGE_SIZE = _10MB;
export const MAX_VIDEO_SIZE = _1MB * 10;
export const MAX_CSV_SIZE = _1MB * 10;
export const QUANTITY_LOAD_MORE = 50;
export const QUANTITY_LOAD_MORE_STUDENT_CARD = 30;
export const QUANTITY_LOAD_MORE_STUDENT_MESSAGE = 30;
export const QUANTITY_LOAD_MORE_MAIL_MESSAGE = 30;
export const QUANTITY_LOAD_MORE_CATEGORY_SETTING = 20;
export const QUESTION_TYPE_CHECKBOX = '4';
export const IMPORT_CSV_ITEM_EVENT = 1;
export const IMPORT_CSV_ITEM_FLOW = 2;
export const IMPORT_CSV_ITEM_OTHER = 3;
export const LINE_PACKAGE_FREE = 1;
export const LINE_PACKAGE_LIGHT = 2;
export const LINE_PACKAGE_STANDARD = 3;
export const HIDDEN_CLASS = 'hidden';
export const MAX_LENGTH_SHOW_TOOLTIP_EVENT = 50;
export const MAX_LENGTH_SHOW_TOOLTIP_PRIVATE_LINE_TALK = 11;
export const MAX_LENGTH_SHOW_TOOLTIP_TAG_NAME_AUTO_REMIND = 17;
export const MAX_LENGTH_SHOW_TOOLTIP_NAME_HISTORY_DOWNLOAD_FILE = 16;
export const MAX_LENGTH_SHOW_TOOLTIP_NAME_PRIVATE_LINE_TALK_SETTING = 31;
export const MAX_LENGTH_SHOW_TOOLTIP_ITEM_FOLDER_NAME = 12;
export const MAX_LENGTH_SHOW_TOOLTIP_MODAL_DOWNLOAD_CSV = 11;
export const REFRESH_FIRST_PAGE_STUDENT_TIME = 300000;
export const SKIP_CHECK_STUDENT_REFRESH_FIRST_PAGE_STUDENT_TIME = 120000;
export const REFRESH_FIRST_PAGE_STUDENT_TIME_GROUP_TALK = 300000;
export const PREVIEW_FILE_TYPE_REGEX = /image\/(jpg|jpeg|png|gif)$|application\/pdf$/i;
export const LIMITED_ERROR_MESSAGE = 2;
export const STATUS_DEFAULT = '参加予定';
export const STATUS_JOIN = '出席';
export const STATUS_CANCEL_BEFORE = '事前キャンセル';
export const STATUS_CANCEL_ON_TAKE_PLACE_DATE = '当日キャンセル';
export const STATUS_CANCEL_ON_SCHEDULE_ADJUSTMENT = '日程調整中';
export const SCREEN_NAME = {
    STUDENT_DETAIL: 'student-detail',
    PRIVATE_LINE_TALK: 'private-talk',
    STUDENT_LIST: 'student_list',
};

//student cards
export const REACH_DATE_WARNING = 30;
export const STUDENT_STATUS = {
    UNSPECIFIED: 1, //指定なし
    DONE: 2, // 実施済
    ADJUSTED: 3, // 調整済
    UNADJUSTED: 4, // 未調整
    PENDING: 5, // 放流中
    REFUSE: 6, // 辞退
};

export const CONTRACT_TERM = {
    DEFAULT: 1,
    CUSTOM: 2,
};

export const EVALUATION_DESIRE = {
    EVALUATION_ASC: 'evaluationAsc',
    EVALUATION_DESC: 'evaluationDesc',
    DESIRE_ASC: 'desireAsc',
    DESIRE_DESC: 'desireDesc',
};

export const DIRECTION = {
    ASC: 'asc',
    DESC: 'desc',
};

export const SORT_TYPE = {
    LAST_REACH_DATE: 'lastReachDate',
    STATUS: 'status',
    EVALUATION_DESIRE: 'evaluationDesire',
};

export const PRIVATE_LINE_TALK = {
    MAX_COUNTER_UNREAD: 99,
    TYPING_TIMEOUT: 5000,
    STATUS: {
        TODO: 2,
        PENDING: 3,
        DONE: 4
    }
};

export const HOURS_PER_DAY = 24;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_MINUTE = 60;
export const SORT_EQUAL = 0;
export const SORT_SMALLER = -1;
export const SORT_BIGGER = 1;
export const MAX_LENGTH_STRING = 255;
export const MIN_LENGTH_STRING = 0;
export const NUMBER_FIRST_ARRAY = 0;
export const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
export const MOMENT_MONTH_FORMAT = 'YYYY-MM';
export const BOOTSTRAP_DATE_FORMAT = 'yyyy-mm-dd';
export const BOOTSTRAP_MONTH_FORMAT = 'yyyy-mm';
export const AUTO_REMIND = {
    TEMPLATE: {
        TEXT_CONTENT: 'App\\Models\\TextContent',
        CAROUSEL_CONTENT: 'App\\Models\\ButtonContent'
    }
};

export const NOTIFICATION_CHANNEL = {
    TYPE: {
        EMAIL: 'App\\Models\\NotificationChannelEmail',
        LINE: 'App\\Models\\NotificationChannelLine'
    },
    CLASS_ICON: {
        EMAIl: 'far fa-envelope',
        LINE: 'fab fa-line'
    }
};

export const AUTO_RESPONSE = {
    TRIGGER_KEYWORD: 'App\\Models\\TriggerKeyword',
    TRIGGER_TIME: 'App\\Models\\TriggerTime',
};

export const ID_DEFAULT = 0;
export const MAX_TEXT_NAME_FOLDER_AUTOREMIND = 13;
export const INIT_FLOW_MAX_LENGTH_TEXT = 13;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_PAGE_EXPIRED = 419;
export const HTTP_FORBIDDEN = 403;
export const HTTP_FOUND = 302;
export const HTTP_CREATED = 201;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE_ENTITY = 422;
export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_REQUEST_TIMEOUT = 504;
export const HTTP_BAD_REQUEST = 400;
export const INTERNAL_SERVER_ERROR = 500;
export const HTTP_METHOD_NOT_ALLOWED = 405;
export const MIN_ARRAY_LENGTH = 0;
export const LINE_NOTIFY_LINK = 'https://notify-bot.line.me/';
export const REGEX_CHECK_EVALUATION_OVERALL = '^[A-Za-z]{1}$';
export const EVALUATION_OVERALL = 'individual_evaluation_overall';
export const PATTERN_FORMAT_DATE_TIME = 'YYYY年 MM月 DD日';
export const PATTERN_FORMAT_MONTH_OF_YEAR = 'YYYY年 MM月';
export const PATTERN_FORMAT_WEEK_OF_MONTH = 'MM月 DD日';
export const PATTERN_FORMAT_YEAR = 'YYYY年';
export const PATTERN_FORMAT_TIME = '午前HH:mm';
export const EVALUATION_ITEM = 'individual_evaluation_items';
export const EVALUATION_NUMBER = 'individual_evaluation_numbers';
export const MAX_STRING_EVALUATION_ITEM = 1000;
export const CUSTOM_FIELD_TYPES = {
    TEXT: 1,
    TEXTAREA: 2,
    CHECKBOX: 4,
    CHECKBOX_CONTRACT: 7,
    FILE: 10,
    DATETIME_PICKER: 11,
};
export const DAYS_PER_MONTH = 30;
export const AUTO_RESPONSE_HIDE_PREVIEW = ['App\\Models\\FormContent', 'App\\Models\\ScenarioContent'];
export const DUPLICATE_TAG = 'のコピー';
export const MAX_TEXT_NAME_RICH_FOLDER = 13;

export const MAX_TEXT_NAME_SCENARIO_FOLDER = 13;
export const OPTION_TARGET = 'シナリオ設定者';
export const OPTION_TARGET_SENDING = 'シナリオ購読中';
export const OPTION_TARGET_COMPLETE = 'シナリオ購読終了';
export const TOTAL_NUMBER_EVALUATION = 20;
export const UNDEFINED_ID = -1;
export const LIMIT_ADD_EVENT_TIME = 100;
export const EVENT_TIME_PLACE_CHARACTER_PER_LINE = 10;
export const EVALUATION_STATUS_PASSED = 1;
export const EVALUATION_STATUS_FAILED = 2;
export const EVALUATION_STATUS_ON_HOLD = 3;
export const STUDENT_DETAIL_SELECTION_TAB = 'SELECTION';
export const STUDENT_DETAIL_LINE_TAB = 'LINE';
export const STUDENT_DETAIL_MAIL_TAB = 'MAIL';
export const STUDENT_DETAIL_MEMO_TAB = 'MEMO';
export const MIN_EXPECTED_PARTICIPANTS = 1;
export const MAX_EXPECTED_PARTICIPANTS = 5000;

export const EVENT_TAG_PASS = '合格';
export const EVENT_TAG_FAIL = '不合格';
export const EVENT_TAG_NO_RESULT = '合否未定';
export const EVENT_TAG_ATTEND = '参加予定';
export const EVENT_TAG_ATTENDING = '出席';
export const EVENT_TAG_CANCEL_BEFORE = '事前キャンセル';
export const EVENT_TAG_CANCEL_ON_TIME = '当日キャンセル';
export const EVENT_TAG_ADJUSTING_SCHEDULE = '日程調整中';

export const STATUS_PASSED = 1;
export const STATUS_FAILED = 2;
export const TIME_LOAD_FLOW_ACTIVE = 800;
export const TIME_LOAD_3000 = 3000;
export const TIME_LOAD_1000 = 1000;
export const TIME_LOAD_500 = 500;
export const DEFAULT_FILTER_TAGS = {
    'ALL' : 0,
    '事前キャンセル' : 0,
    '出席' : 0,
    '参加予定' : 0,
    '当日キャンセル' : 0,
    '日程調整中' : 0,
};
export const HTTP_OK = 200;
export const HTTP_ACCEPTED = 202;
export const AUTO_FOLDER = 'auto_folder';
export const TAG_SHOP = 'payment_shop';
export const TAG_EVENT = 'event';
export const TAG_FOLDER_EVALUATION = '議事録';
export const TAG_FOLDER_INTERVIEWER = '担当者';
export const TAG_SHOP_FOLDER_NAME = '店舗スタッフ';
export const TAG_SHOP_DEFAULT_NAME = '店舗スタッフ';
export const TAG_BOOKING = 'booking';
export const TAG_AUTO_GENERATED = 'auto_generated';
export const TAG_DIVIDE = 'divide';
export const COMPANY_USER_SERVICE_TYPE = {
    1 : 'ATS',
    2 : 'LINEA',
    3 : 'LINEB',
    4 : 'LINEA`',
};

export const  HRPRIME = 'hrprime';
export const UNREADABLE_PERMISSIONS = [
    'CSVインポート',
    'CSVエクスポート',
    'ユーザーカテゴリ',
    'ログイン情報',
    'IPアドレス制限',
    '2段階認証',
    'LINE通知',
    'エントリー経路',
    '受信通知機能',
    'プロフィール項目',
    '重複管理',
    'プロフィール項目',
    '予約管理',
    'メール設定',
    'トークステータス設定',
    'メールアドレス設定',
    '決済機能'
];
export const NOTNONE_PERMISSIONS = [
    'テンプレート',
    'タグ',
    '公式アカウントのアイコン・表示名',
];

export const SERVICE_ALL_PERMISSION = 'ALL';

export const PERMISSION_TYPES = {
    'unable': -1,
    'readable': 0,
    'writable': 1,
};

export const IS_FULL_PERMISSION = '1';
export const CATEGORY_LOGOUT = -1;
export const EVENT = 'event';
export const BOOKING = 'booking';
export const DEFAULT_QR_CODE = 1;
export const ADMIN = 'admin';
export const COMPANY = 'company';
export const STAFF = 'staff';
export const ACTION_DISABLED_CLASS = 'action-disabled';
export const D_NONE_CLASS = 'd-none';

export const PERMISSIONS = {
    'AUTO_REMIND_WRITE': 'auto-remind-write',
    'AUTO_REMIND_READ': 'auto-remind-read',
    'STUDENT_LIST_WRITE': 'student-list-write',
    'STUDENT_LIST_READ': 'student-list-read',
    'EVENT_WRITE': 'event-write',
    'EVENT_READ': 'event-read',
    'INTERVIEW_WRITE': 'interview-write',
    'INTERVIEW_READ': 'interview-read',
    'PRIVATE_TALK_WRITE': 'private-talk-write',
    'PRIVATE_TALK_READ': 'private-talk-read',
    'SEND_BATCH_WRITE': 'send-batch-write',
    'SEND_BATCH_READ': 'send-batch-read',
    'SCENARIO_WRITE': 'scenario-write',
    'SCENARIO_READ': 'scenario-read',
    'RICH_MENU_WRITE': 'rich-menu-write',
    'RICH_MENU_READ': 'rich-menu-read',
    'AUTO_RESPONSE_WRITE': 'auto-response-write',
    'AUTO_RESPONSE_READ': 'auto-response-read',
    'QR_CODE_WRITE': 'qr-code-write',
    'QR_CODE_READ': 'qr-code-read',
    'LINE_FORM_WRITE': 'line-form-write',
    'LINE_FORM_READ': 'line-form-read',
    'TAG_WRITE': 'tag-write',
    'TAG_READ': 'tag-read',
    'TEMPLATE_WRITE': 'template-write',
    'TEMPLATE_READ': 'template-read',
    'CSV_IMPORT_WRITE': 'csv-import-write',
    'CSV_EXPORT_WRITE': 'csv-export-write',
    'STUDENT_DETAIL_WRITE': 'student-detail-write',
    'STUDENT_DETAIL_READ': 'student-detail-read',
    'INIT_FLOW_WRITE': 'init-flow-write',
    'INIT_FLOW_READ': 'init-flow-read',
    'DASHBOARD_WRITE': 'dashboard-write',
    'DASHBOARD_READ': 'dashboard-read',
    'USER_CATEGORY_WRITE': 'user-category-write',
    'LOGIN_INFO_WRITE': 'login-info-write',
    'IP_ADDRESS_ACCESS_ROLE_WRITE': 'ip-address-access-role-write',
    'TWO_FACTOR_AUTH_WRITE': 'two-factor-auth-write',
    'LINE_NOTIFY_WRITE': 'line-notify-write',
    'IMPORT_SETTING_WRITE': 'import-setting-write',
    'PROFILE_SETTING_WRITE': 'profile-setting-write',
    'NOTIFICATION_WRITE': 'notification-write',
    'DUPLICATION_WRITE': 'duplication-write',
    'RECRUIT_WRITE': 'recruit-write',
    'RECRUIT_READ': 'recruit-read',
    'CREATE_INTERVIEW_ASSESSMENT_WRITE': 'create-interview-assessment-write',
    'CREATE_INTERVIEW_ASSESSMENT_READ': 'create-interview-assessment-read',
    'CALENDAR_WRITE': 'calendar-write',
    'PRIVATE_MAIL_WRITE': 'private-mail-write',
    'MAIL_SETTING_WRITE': 'email-setting-write',
    'PRIVATE_LINE_STATUS_SETTING': 'private-line-status-setting-write',
};

// dashboard
export const CHART_TARGET_ADVANCED_SEARCH = 1;
export const CHART_TARGET_TAG = 2;
export const CHART_TYPE_LINE = 0;
export const CHART_TYPE_BAR = 1;
export const CHART_TARGET_LIMIT = 20;
export const CHART_TARGET_NAME_LIMIT = 30;
export const CHART_NAME_LIMIT = 30;

export const OPTION_TIME_FOR_CHART = {
    0: '日別',
    1: '週別',
    2: '月別',
};

export const FORMAT_YMD = 'YYYY/MM/DD';
export const FORMAT_LLL = 'lll';
export const FORMAT_YM = 'YYYY/MM';

// LINE form
export const QUESTION_TYPE_SURVEY = 1;
export const QUESTION_TYPE_PROFILE = 2;
export const RULE_KEY_PHONE_NUMBER = 4;
export const PHONE_NUMBER_FORMAT = 10;
export const FIELD_TYPE_TEXT = 1;
export const FIELD_TYPE_TEXT_AREA = 2;
export const FIELD_TYPE_FILE = 10;
export const FIELD_AUTO_COMPLETE = 6;
export const FIELD_TYPE_DATETIME_PICKER = 11;

export const QUESTION_TYPES = {
    1: 'アンケート項目',
    2: 'プロフィール項目',
};

export const QUESTION_TYPE_PROFILE_SETTING = 2;

export const TAG_LIST_TYPE = {
    0: 'tag_folder_list',
    1: 'fixed_tag_folder_list',
    2: 'recruiter_source_folder_list',
    3: 'not_event_tag_folder',
    4: 'tag_folder_list_not_tag_auto',
    5: 'not_booking_tag_folder'
};

export const STUDENT_LIST_SET_EVENT = 1;
export const STUDENT_LIST_SET_FLOW = 2;
export const WINDOW_WIDTH_RESPONSIVE = 1025;
export const WINDOW_WIDTH_RESPONSIVE_MOBILE = 1025;
export const MAX_EMAIL_NOTIFICATION_CHANNEL = 100;

// Category Setting
export const CATEGORY_SETTING_NAME_MAX_LENGTH = 150;
export const TEMPLATE_SCHEDULE_SEND_NOW = 'send now';
export const TEMPLATE_SCHEDULE_SEND_LATER = 'send later';

//Date picker label
export const DATE_PICKER_MONTH_LABEL = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
export const DATE_PICKER_DAY_OF_WEEK_LABEL = ['日', '月', '火', '水', '木', '金', '土'];
export const DATE_PICKER_CUSTOM_RANGE_LABEL = '独自の範囲';
export const DATE_PICKER_WEEK_LABEL = '週';

// My page
export const DEFAULT_MYPAGE_WORD_SETTING = 'mypage';
export const MY_PAGE_FORMAT_TIME = 'HH:mm';
export const MY_PAGE_TIME = 'HH:mm:ss';
export const MY_PAGE_MAX_FILE_UPLOAD = 10;
export const MY_PAGE_PLACE_CHARACTER_PER_LINE = 25;

// Form
export const FORM_MAX_FILE_UPLOAD = 10;
export const QUESTION_TYPE_UPLOAD_FILE = 10;
export const FORM_MAX_FILE_UPLOAD_SIZE = 20;
export const FORM_FILE_EXTENSION = ['.jpg', '.jpeg', '.bmp', '.gif', '.png', '.psd', '.ai', '.avi', '.mpeg', '.mpg', '.mp4', '.mov', '.csv', '.pdf', '.key', '.docx', '.doc', '.xls', '.xlsx', '.ppt', '.pptx'];

export const BROADCAST_MAIL_STATUS = {
    UNSENT: 0,
    SENT: 1,
    CANCEL: 2,
    SENDING: 3,
    DRAFT: 9,
    SEND_FREQUENCY: 10,
    API_TEMPLATE: 11,
    DISPLAY_UNSENT: 0,
    DISPLAY_SENT: 1,
    DISPLAY_CANCEL: 2,
    DISPLAY_SENDING: 3,
    LINE_NOTIFY: 12,
};

// ref to config/user.php key line_package_charge
export const TOTAL_MESSAGE_FREE_LINE_PACKAGE_FREE = 1000;
export const TOTAL_MESSAGE_FREE_LINE_PACKAGE_LIGHT = 15000;
export const TOTAL_MESSAGE_FREE_LINE_PACKAGE_STANDARD = 45000;

export const DENIED_WORD_STATUS = {
    OFF: 0,
    ON: 1,
};

export const CALENDAR_FLOW_STEPS = {
    MIN: 15,
    MAX: 360,
    STEP: 15,
};

export const CALENDAR_RECEPTION_END_TIME_STEPS = {
    MIN: 0,
    MAX: 360,
    STEP: 5,
};

export const CALENDAR_DISPLAY_TIME_STEP_TYPES = {
    0: '開始時間のみ',
    1: '開始時間～終了時間',
};

export const CALENDAR_AUTOREMIND = {
    MIN: 0,
    MAX: 10,
    DEFAULT_REMIND: {
        text: null,
        hour: 17,
        minute: 0,
        remind_day: 1,
    },
};

export const CALENDAR_WORKING_TIME = {
    DEFAULT_LIMIT: 3,
    DEFAULT_VALUE: ['09:00', '20:00'],
    DEFAULT_OFF_TIME_STATUS: 0,
    DEFAULT_OFF_TIME: ['12:00', '13:00'],
};

export const CALENDAR_BOOKING_TIME = {
    DEFAULT_LIMIT: 3,
    DEFAULT_VALUE: ['09:00', '20:00']
};

export const CALENDAR_BREAK_TIME = {
    DEFAULT_VALUE: ['12:00', '13:00']
};

export const CALENDAR_DAYS_OF_WEEK = [
    {
        key: 'sun',
        text: '日曜',
    },
    {
        key: 'mon',
        text: '月曜',
    },
    {
        key: 'tue',
        text: '火曜',
    },
    {
        key: 'wed',
        text: '水曜',
    },
    {
        key: 'thu',
        text: '木曜',
    },
    {
        key: 'fri',
        text: '金曜',
    },
    {
        key: 'sat',
        text: '土曜',
    },
    {
        key: 'holiday',
        text: '祝日',
    },
];

export const MY_CALENDAR_DEFAULT_COLOR = [
    '#a0ced9',
    '#ffe660',
    '#f3a712',
    '#cd9fcc',
    '#f3d8c7',
    '#d5573b',
    '#db3069',
    '#52528c',
    '#00534c',
    '#44ffae',
    '#daff7d',
    '#f6f5ae',
    '#2e4057',
    '#00b574',
    '#44e3ff',
    '#23b5d3',
    '#c5d86d',
    '#fdd49f',
    '#118ab2',
    '#04395e',
];

export const CHECKED_QUICK_BOOKING_COLOR = '#434343';
export const PRIVATE_LINE_STATUS_SETTING_DEFAULT_COLOR = '#009CE0';

export const OPTION_TIME_FOR_CALENDAR = {
    1: '日',
    2: '週',
    3: '月',
    4: '年',
};

export const OPTION_TIME_KEY_FOR_CALENDAR = {
    DAY: 1,
    WEEK: 2,
    MONTH: 3,
    YEAR: 4,
};

export const CALENDAR_MENU = {
    MIN_EXECUTE_TIME: 0,
    MAX_EXECUTE_TIME: 360,
    STEP: 5,
};

export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const URICONTENTCLASS = 'App\\Models\\UrlContent';
export const TEXTCONTENTCLASS = 'App\\Models\\TextContent';
export const CALENDAR_STATUS = {
    'booking' : 1,
    'cancel' : 2,
    'end' : 3,
};

export const STICKER_IMAGE_ANIMATION_URL = 'https://stickershop.line-scdn.net/stickershop/v1/sticker/__STICKER_ID__/iPhone/sticker_animation@2x.png;compress=true';
export const STICKER_IMAGE_URL = 'https://stickershop.line-scdn.net/stickershop/v1/sticker/__STICKER_ID__/android/sticker.png;compress=true';

export const CALENDAR_DEFAULT_IMAGES = {
    MENU: '/img/pct-menu.png',
    CATEGORY: '/img/pct-category.png',
};

export const RATIO = 0.081552;
export const WIDTH_DEFAULT = 2500;
export const HEIGHT_DEFAULT = 1686;
export const MAX_WIDTH = 1040;
export const MIN_WIDTH = 240;
export const RICH_MENU_SCREEN = 'rich_menu';

// Mail box
export const MAIL = {
    UNREAD: 0,
    READ: 1,
    MAIL_BOX_TYPES: {
        ALL: 'all',
        UNREAD: 'unread',
        STARRED: 'starred',
    },
    MAIL_SETTING_ALL: 'all',
    MAIL_SETTING_DRAFT: 'draft',
    MAIL_SETTING_SENT: 'sent',
    TYPE_FOLDER: {
        INBOX: 1,
        SENT: 2,
        DRAFT: 3,
        TRASH: 4,
    },
    TYPE_EMAIL_THREAD: {
        UNREAD: 1,
        SENT: 2,
        UNREGISTERED_EMAIL: 3,
        STARRED: 4,
        ALL: 5,
    },
    NUMBER_EMPTY_LINE: 2,
    AUTO_SAVE_TIME: 1000,
    MAX_FILE_SIZE: 10000000,
    RECEIVER_TYPE: {
        TO: 1,
        CC: 2,
        BCC: 3,
    },
    ATTACHMENT_TYPE: {
        FILE: 'file',
        IMAGE: 'image',
        VIDEO: 'video',
    },
    STARRED_STATUS: {
        NOT_STARRED: 0,
        STARRED: 1,
    },
    UPLOAD_PERCENTAGE_START: 0,
    MAX_LENGTH_ATTACHMENT_NAME: 12,
};

//Mail setting
export const IMAP_DEFAULT_PORT = 143;
export const POP_DEFAULT_PORT = 110;
export const SMTP_DEFAULT_PORT = 587;

export const BROADCAST_MAIL_TYPES = {
    LINE: 1,
    MAIL: 2,
    LINE_AND_MAIL: 3,
    LINE_NOTIFY_PHONE: 4,
};

export const BROADCAST_MAIL_SEND_METHOD = {
    LARGE_SCALE_BROADCAST: 2,
    NARROW_CAST: 1,
    NORMAL: 0,
    LINE_NOTIFY_PHONE: 3,
};

export const BROADCAST_MAIL_SEND_NUMBER_DEFAULT = 1;
export const BROADCAST_MAIL_SEND_NUMBER_MAX = 100;
export const BROADCAST_MAIL_FREQUENCY_NUMBER_DEFAULT = 7;
export const BROADCAST_MAIL_FREQUENCY_NUMBER_MAX = 70;
export const BROADCAST_MAIL_FREQUENCY_DATE_FORMAT = 'YYYY-M-DD';

export const MODEL_NAMESPACE = {
    'text_content': 'App\\Models\\TextContent',
    'image_content': 'App\\Models\\ImageContent',
    'video_content': 'App\\Models\\VideoContent',
    'button_content': 'App\\Models\\ButtonContent',
    'carousel_content': 'App\\Models\\CarouselContent',
    'form_content': 'App\\Models\\FormContent',
    'image_carousel': 'App\\Models\\ImageCarouselContent',
    'image_carousel_flex': 'App\\Models\\ImageCarouselFlexContent',
};

export const OPTION_STATUS_ANSWERED_LINE_FORM = {
    0: '未回答',
    1: '回答済み',
};

export const OPTION_DISPLAY_STUDENT_WITH_STATUS_BLOCKED_OR_BLOCKING = {
    0: '表示',
    1: '非表示',
    2: 'ブロックされた人のみ表示',
};

export const OPTION_DISPLAY_STUDENT_WITH_STATUS_BLOCKED = {
    0: '表示',
    1: '非表示',
    2: 'ブロックした人のみ表示',
};

export const OPTION_DISPLAY_STUDENT_WITH_STATUS_BLOCKING = {
    0: '表示',
    1: '非表示',
    2: 'ブロックされた人のみ表示',
};

export const OPTION_TYPE_TIME = {
    0: '時間内',
    1: '時間外',
};

export const STICKER = [
    {
        package_id: 11537,
        package_name: 'Brown, Cony & Sally',
        from: 52002734,
        to: 52002773,
    },
    {
        package_id: 11538,
        package_name: 'CHOCO & Friends',
        from: 51626494,
        to: 51626533,
    },
    {
        package_id: 11539,
        package_name: 'UNIVERSTAR BT21',
        from: 52114110,
        to: 52114149,
    },
];

export const STAFF_TYPE = 'staff';
export const OPTION_DISPLAY_STUDENT_WITH_STATUS_BLOCKED_OR_BLOCKING_PERSON = {
    0: '表示',
    1: '非表示',
    2: 'ブロックされた人のみ表示',
};

export const SEND_MESSAGE_FAIL = 1;
export const SEND_MESSAGE_LOADING = 2;
export const SEND_MESSAGE_SUCCESS = 3;
export const SENT_STATUS_SENDING = 1;
export const SENT_STATUS_FAIL = 3;

export const CALENDAR_FLOW_WORKING_TIME_DEFAULT = '09:00';
export const CALENDAR_FLOW_WORKING_TIME_END_DEFAULT = '20:00';
export const CALENDAR_FLOW_BREAKING_TIME_DEFAULT = '12:00';
export const CALENDAR_FLOW_BREAKING_TIME_END_DEFAULT = '13:00';
export const CALENDAR_BREAKING_TIME_STEP_DEFAULT = 5;
export const CALENDAR_WORKING_TIME_STEP_DEFAULT = 5;
export const CALENDAR_FLOW_START_TIME_OF_DAY_DEFAULT = '00:00';
export const TIME_QUESTION_DEFAULT = '00';
export const FORMAT_HOUR_DEFAULT = 'AM';
export const TYPE_WORKING = 'working';
export const TYPE_BREAKING = 'breaking';

export const PRIVATE_TALK_TABS = {
    LINE: 'line',
    EMAIL: 'email',
};
export const ACTIVITY_TYPE_CALENDAR = 0;
export const ACTIVITY_TYPE_PAYMENT = 1;
export const ORDER_NUMBER_CONVERT = 1000000;

export const PAYMENT_BUTTON_GREEN = '#00d607';
export const EVALUATION_OPTION_TIME_DELAY = 1000;
export const SCREEN_RESOURCE = {
    'EVENT': 'event',
};
export const FONT_SIZE_SETTING_TYPE = {
    NORMAL: 0,
    LARGE: 1,
};

export const LIMIT_STUDENT_INFO_REGEX = /.{1,18}/g;

export const HISTORY_DOWNLOAD_FILE = {
    'IN_PROGRESS': 1,
    'COMPLETED': 2,
    'FAILURE': 3,
};

export const VIEW_MODE_PICKER = {
    days: 0,
    months: 1,
    years: 2,
};

export const EXPORT_TIMES = {
    MONTH_TIMES_FOR_DAY: 3,
    YEAR_TIMES_FOR_WEEK: 1,
    YEAR_TIMES_FOR_MONTH: 5,
};

export const EMOJI = {
    search: '検索',
    notfound: '見つかりません',
    categories: {
        search: '検索結果',
        recent: 'よく使う絵文字',
        people: 'スマイリーと人々',
        nature: '動物と自然',
        foods: '食べ物と飲み物',
        activity: '活動',
        places: '旅行と場所',
        objects: '物',
        symbols: '記号',
        flags: '旗',
        custom: 'カスタム',
    }
};

export const EMOJI_CODE_TO_IMAGE = {
    '(scissors)': '<img class="emoji" draggable="false" src="storage/image/emoji/100030.png">',
    '(ear)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002F.png">',
    '(eyes)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002E.png">',
    '(shiny)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002D.png">',
    '(lips)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002C.png">',
    '(sleepy)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002B.png">',
    '(dash)': '<img class="emoji" draggable="false" src="storage/image/emoji/10002A.png">',
    '(drop)': '<img class="emoji" draggable="false" src="storage/image/emoji/100029.png">',
    '(surprise)': '<img class="emoji" draggable="false" src="storage/image/emoji/100027.png">',
    '(rage)': '<img class="emoji" draggable="false" src="storage/image/emoji/100026.png">',
    '(imp)': '<img class="emoji" draggable="false" src="storage/image/emoji/100024.png">',
    '(yummy)': '<img class="emoji" draggable="false" src="storage/image/emoji/100023.png">',
    '(catface)': '<img class="emoji" draggable="false" src="storage/image/emoji/100022.png">',
    '(dazed)': '<img class="emoji" draggable="false" src="storage/image/emoji/100021.png">',
    '(mask)': '<img class="emoji" draggable="false" src="storage/image/emoji/100020.png">',
    '(dozing)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001F.png">',
    '(angry)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001E.png">',
    '(pouting)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001D.png">',
    '(scream)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001C.png">',
    '(astonished)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001B.png">',
    '(tearsofjoy)': '<img class="emoji" draggable="false" src="storage/image/emoji/10001A.png">',
    '(crying)': '<img class="emoji" draggable="false" src="storage/image/emoji/100019.png">',
    '(tear)': '<img class="emoji" draggable="false" src="storage/image/emoji/100018.png">',
    '(tired)': '<img class="emoji" draggable="false" src="storage/image/emoji/100017.png">',
    '(anguished)': '<img class="emoji" draggable="false" src="storage/image/emoji/100016.png">',
    '(exasperated)': '<img class="emoji" draggable="false" src="storage/image/emoji/100015.png">',
    '(unbearable)': '<img class="emoji" draggable="false" src="storage/image/emoji/100013.png">',
    '(disappointed)': '<img class="emoji" draggable="false" src="storage/image/emoji/100012.png">',
    '(hm)': '<img class="emoji" draggable="false" src="storage/image/emoji/100011.png">',
    '(bittersmile)': '<img class="emoji" draggable="false" src="storage/image/emoji/100010.png">',
    '(smirk)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000F.png">',
    '(unamused)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000E.png">',
    '(funny)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000D.png">',
    '(kidding)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000C.png">',
    '(grin)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000B.png">',
    '(relief)': '<img class="emoji" draggable="false" src="storage/image/emoji/10000A.png">',
    '(baffled)': '<img class="emoji" draggable="false" src="storage/image/emoji/100009.png">',
    '(kiss)': '<img class="emoji" draggable="false" src="storage/image/emoji/100008.png">',
    '(blowkiss)': '<img class="emoji" draggable="false" src="storage/image/emoji/100007.png">',
    '(glad)': '<img class="emoji" draggable="false" src="storage/image/emoji/100006.png">',
    '(wink)': '<img class="emoji" draggable="false" src="storage/image/emoji/100005.png">',
    '(blush)': '<img class="emoji" draggable="false" src="storage/image/emoji/100004.png">',
    '(laugh)': '<img class="emoji" draggable="false" src="storage/image/emoji/100003.png">',
    '(smile)': '<img class="emoji" draggable="false" src="storage/image/emoji/100002.png">',
    '(happy)': '<img class="emoji" draggable="false" src="storage/image/emoji/100001.png">',
    '(car)': '<img class="emoji" draggable="false" src="storage/image/emoji/100049.png">',
    '(train)': '<img class="emoji" draggable="false" src="storage/image/emoji/100047.png">',
    '(soccerball)': '<img class="emoji" draggable="false" src="storage/image/emoji/100045.png">',
    '(tennisball)': '<img class="emoji" draggable="false" src="storage/image/emoji/100044.png">',
    '(golfball)': '<img class="emoji" draggable="false" src="storage/image/emoji/100043.png">',
    '(baseball)': '<img class="emoji" draggable="false" src="storage/image/emoji/100042.png">',
    '(pencil)': '<img class="emoji" draggable="false" src="storage/image/emoji/100041.png">',
    '(loveletter)': '<img class="emoji" draggable="false" src="storage/image/emoji/100040.png">',
    '(cellphone)': '<img class="emoji" draggable="false" src="storage/image/emoji/10003D.png">',
    '(phone)': '<img class="emoji" draggable="false" src="storage/image/emoji/10003C.png">',
    '(PC)': '<img class="emoji" draggable="false" src="storage/image/emoji/10003B.png">',
    '(thunder)': '<img class="emoji" draggable="false" src="storage/image/emoji/10003A.png">',
    '(eighthnote)': '<img class="emoji" draggable="false" src="storage/image/emoji/100039.png">',
    '(brokenheart)': '<img class="emoji" draggable="false" src="storage/image/emoji/100038.png">',
    '(heart)': '<img class="emoji" draggable="false" src="storage/image/emoji/100037.png">',
    '(!?)': '<img class="emoji" draggable="false" src="storage/image/emoji/100036.png">',
    '(!)': '<img class="emoji" draggable="false" src="storage/image/emoji/100035.png">',
    '(ok)': '<img class="emoji" draggable="false" src="storage/image/emoji/100033.png">',
    '(rock)': '<img class="emoji" draggable="false" src="storage/image/emoji/100032.png">',
    '(paper)': '<img class="emoji" draggable="false" src="storage/image/emoji/100031.png">',
    '(rose)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B8.png">',
    '(medicine)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B7.png">',
    '(chocolate cake)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B6.png">',
    '(bed)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B5.png">',
    '(calculator)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B4.png">',
    '(2 stars)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B3.png">',
    '(star)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B2.png">',
    '(2 hearts)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B1.png">',
    '(3 hearts)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B0.png">',
    '(1 heart)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AF.png">',
    '(clap)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AE.png">',
    '(boo)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AD.png">',
    '(cloud)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AC.png">',
    '(snow)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AB.png">',
    '(rain)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000AA.png">',
    '(sun)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A9.png">',
    '(moon)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A8.png">',
    '(toilet)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A7.png">',
    '(no)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A6.png">',
    '(yes)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A5.png">',
    '(fire)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A4.png">',
    '(skull)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A2.png">',
    '(halloween)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A1.png">',
    '(ghost)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A0.png">',
    '(argh!)': '<img class="emoji" draggable="false" src="storage/image/emoji/10009E.png">',
    '(aww)': '<img class="emoji" draggable="false" src="storage/image/emoji/10009D.png">',
    '(doze off)': '<img class="emoji" draggable="false" src="storage/image/emoji/10009C.png">',
    '(panic)': '<img class="emoji" draggable="false" src="storage/image/emoji/10009B.png">',
    '(sharp)': '<img class="emoji" draggable="false" src="storage/image/emoji/10009A.png">',
    '(half dead)': '<img class="emoji" draggable="false" src="storage/image/emoji/100099.png">',
    '(brr)': '<img class="emoji" draggable="false" src="storage/image/emoji/100098.png">',
    '(hmph)': '<img class="emoji" draggable="false" src="storage/image/emoji/100097.png">',
    '(cony kiss)': '<img class="emoji" draggable="false" src="storage/image/emoji/100096.png">',
    '(at last!)': '<img class="emoji" draggable="false" src="storage/image/emoji/100095.png">',
    '(ah...)': '<img class="emoji" draggable="false" src="storage/image/emoji/100094.png">',
    '(nom nom)': '<img class="emoji" draggable="false" src="storage/image/emoji/100093.png">',
    '(blue)': '<img class="emoji" draggable="false" src="storage/image/emoji/100092.png">',
    '(gasp!)': '<img class="emoji" draggable="false" src="storage/image/emoji/100091.png">',
    '(content)': '<img class="emoji" draggable="false" src="storage/image/emoji/100090.png">',
    '(moon wink)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008F.png">',
    '(oops)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008E.png">',
    '(moon grin)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008D.png">',
    '(hee)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008C.png">',
    '(attracted)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008B.png">',
    '(james wink)': '<img class="emoji" draggable="false" src="storage/image/emoji/10008A.png">',
    '(what?!)': '<img class="emoji" draggable="false" src="storage/image/emoji/100089.png">',
    '(worn out)': '<img class="emoji" draggable="false" src="storage/image/emoji/100088.png">',
    '(who, me?)': '<img class="emoji" draggable="false" src="storage/image/emoji/100087.png">',
    '(goodnight)': '<img class="emoji" draggable="false" src="storage/image/emoji/100086.png">',
    '(eh?!)': '<img class="emoji" draggable="false" src="storage/image/emoji/100085.png">',
    '(hello)': '<img class="emoji" draggable="false" src="storage/image/emoji/100084.png">',
    '(frozen)': '<img class="emoji" draggable="false" src="storage/image/emoji/100083.png">',
    '(tongue out)': '<img class="emoji" draggable="false" src="storage/image/emoji/100082.png">',
    '(kiss me)': '<img class="emoji" draggable="false" src="storage/image/emoji/100081.png">',
    '(sparkling eyes)': '<img class="emoji" draggable="false" src="storage/image/emoji/100080.png">',
    '(haha)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007F.png">',
    '(super angry)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007E.png">',
    '(oh no!)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007D.png">',
    '(sad)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007C.png">',
    '(shocked)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007B.png">',
    '(please!)': '<img class="emoji" draggable="false" src="storage/image/emoji/10007A.png">',
    '(hahaha)': '<img class="emoji" draggable="false" src="storage/image/emoji/100079.png">',
    '(love)': '<img class="emoji" draggable="false" src="storage/image/emoji/100078.png">',
    '(lightbulb)': '<img class="emoji" draggable="false" src="storage/image/emoji/100077.png">',
    '(birthday)': '<img class="emoji" draggable="false" src="storage/image/emoji/100076.png">',
    '(gift)': '<img class="emoji" draggable="false" src="storage/image/emoji/100075.png">',
    '(ring)': '<img class="emoji" draggable="false" src="storage/image/emoji/100074.png">',
    '(crown)': '<img class="emoji" draggable="false" src="storage/image/emoji/100073.png">',
    '(purse)': '<img class="emoji" draggable="false" src="storage/image/emoji/100072.png">',
    '(clock)': '<img class="emoji" draggable="false" src="storage/image/emoji/100071.png">',
    '(headphones)': '<img class="emoji" draggable="false" src="storage/image/emoji/100070.png">',
    '(cinema)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006F.png">',
    '(videogame)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006E.png">',
    '(TV)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006D.png">',
    '(book)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006C.png">',
    '(poop)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000A3.png">',
    '(bag)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006B.png">',
    '(camera)': '<img class="emoji" draggable="false" src="storage/image/emoji/10006A.png">',
    '(ribbon)': '<img class="emoji" draggable="false" src="storage/image/emoji/100069.png">',
    '(lipstick)': '<img class="emoji" draggable="false" src="storage/image/emoji/100068.png">',
    '(highheels)': '<img class="emoji" draggable="false" src="storage/image/emoji/100067.png">',
    '(nosmoking)': '<img class="emoji" draggable="false" src="storage/image/emoji/100066.png">',
    '(cigar)': '<img class="emoji" draggable="false" src="storage/image/emoji/100065.png">',
    '(wave)': '<img class="emoji" draggable="false" src="storage/image/emoji/100064.png">',
    '(tulip)': '<img class="emoji" draggable="false" src="storage/image/emoji/100062.png">',
    '(flower)': '<img class="emoji" draggable="false" src="storage/image/emoji/100060.png">',
    '(cat)': '<img class="emoji" draggable="false" src="storage/image/emoji/10005F.png">',
    '(dog)': '<img class="emoji" draggable="false" src="storage/image/emoji/10005E.png">',
    '(pig)': '<img class="emoji" draggable="false" src="storage/image/emoji/10005D.png">',
    '(chick)': '<img class="emoji" draggable="false" src="storage/image/emoji/10005C.png">',
    '(apple)': '<img class="emoji" draggable="false" src="storage/image/emoji/10005B.png">',
    '(coffee)': '<img class="emoji" draggable="false" src="storage/image/emoji/100059.png">',
    '(beer)': '<img class="emoji" draggable="false" src="storage/image/emoji/100058.png">',
    '(cocktail)': '<img class="emoji" draggable="false" src="storage/image/emoji/100057.png">',
    '(cake)': '<img class="emoji" draggable="false" src="storage/image/emoji/100056.png">',
    '(hamburger)': '<img class="emoji" draggable="false" src="storage/image/emoji/100055.png">',
    '(noodles)': '<img class="emoji" draggable="false" src="storage/image/emoji/100054.png">',
    '(gasstation)': '<img class="emoji" draggable="false" src="storage/image/emoji/100053.png">',
    '(spa)': '<img class="emoji" draggable="false" src="storage/image/emoji/100051.png">',
    '(bank)': '<img class="emoji" draggable="false" src="storage/image/emoji/100050.png">',
    '(school)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004F.png">',
    '(hospital)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004E.png">',
    '(postoffice)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004D.png">',
    '(building)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004C.png">',
    '(bicycle)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004B.png">',
    '(plane)': '<img class="emoji" draggable="false" src="storage/image/emoji/10004A.png">',
    '(rose stalk)': '<img class="emoji" draggable="false" src="storage/image/emoji/1000B9.png">',
};

export const MAX_IMAGE_AREA = 50;

export const LINEB_SERVICE = 'LINEB';

export const ATS_SERVICE = 'ATS';

export const MAX_LENGTH_OF_QR_CODE_NAME = 25;

export const ITEM_STATUS_DEFAULT = '何もしない';

export const DOMAIN_AURA='aura-mico.jp';
export const DOMAIN_MPRIME='m-prime.jp';
export const DOMAIN_RESERBO='reserbo.jp';
export const DOMAIN_TNEXTLINE='tnextline.mico-cloud.jp';

export const MINI_TAG_TIME_OUT = {
    CLICK_EVENT: 100,
    SCROLL_EVENT: 500,
    RESTORE_ITEM: 500
};

export const MINI_TAG_VIEW = {
    WINDOW: 3,
    OFFSET: 100,
    PER_PAGE: 50,
    SCROLL_UP: 1450,
    DEFAULT_PAGE: 0
};

export const MINI_TAG_FOLDER_TYPES = {
    LIST: 'tag_folder_list',
    NOT_AUTO: 'tag_folder_list_not_tag_auto',
    NOT_EVENT: 'not_event_tag_folder',
    FIXED: 'fixed_tag_folder_list',
    RECRUITER_SOURCE: 'recruiter_source_folder_list',
    NOT_BOOKING: 'not_booking_tag_folder',
};

export const BLANK_KEY_CODES = [8, 13, 27, 35, 36, 37, 38, 39, 40, 46];

export const FILE_SHOW_MYPAGE_STATUSES = [
    {text: 'マイページ閲覧不可', value:false},
    {text: 'マイページ閲覧可', value:true},
];

export const SURVEY_TYPE = {
    0: 'デフォルト',
};

export const SURVEY_TYPE_DEFAULT = 'default';
export const SURVEY_TYPE_WEDDING = 'wedding';
export const SURVEY_TYPE_DEFAULT2 = 'default2';
export const SURVEY_TYPE_DEFAULT2_TEXT = 'デフォルト2';
export const SURVEY_TYPE_SCHOOL = 'school';
export const SURVEY_TYPE_BASIC_TEXT = 'Basic';
export const SURVEY_TYPE_BASIC = 'basic';

export const PATH_WEDDING_PAYMENT = {
    KAIHI: 'kaihi_payment',
    OIWAIKIN: 'oiwaikin_payment'
};

export const PAYMENT_TYPES = {
    CREDIT_CARD: 1,
    LINE_PAY: 2,
    BANK_PAY: 3,
    COD: 4
};


export const GMO_CODE_OK = '000';

export const WD_FORM_WEDDING_MAX_RELATION_PERSON = 8;

export const WD_FORM_PAYMENT_INPUT_LIMIT = {
    CARD_NO: '####################',//Using v-mask. Max 20 character is number
    EXPIRE_MONTH: '##', //Using v-mask. Max 2 character is number
    EXPIRE_YEAR: '####', //Using v-mask. Max 4 character is number
    SECURITY_CODE: '###', //Using v-mask. Max 4 character is number
};

export const FIELD_ZIP_CODE = 7;

export const FIELD_TYPE_ZIP_CODE = 1;

export const FIELD_ZIP_CODE_MASK = '###-####';

export const FIELD_PHONE_NUMBER_MASK = '###-####-####';

export const FIELD_TYPE_AUTO_FILL_ZIP_CODE = [1, 2];

export const RULE_AUTO_FILL_ZIP_CODE_DEFAULT = 'なし';

export const INDEX_FIELD_ZIP_CODE_DEFAULT = 0;

export const CART_ERROR_TYPES = {
    REMOVE_ITEM: 1,
    REDUCE_ITEM_QUANTITY: 2
};

export const CREDIT_CARD_PAYMENT_INPUT_LIMIT = {
    CARD_NO: '####################',//Using v-mask. Max 20 character is number
    EXPIRE_MONTH: '##', //Using v-mask. Max 2 character is number
    EXPIRE_YEAR: '####', //Using v-mask. Max 4 character is number
    SECURITY_CODE: '####', //Using v-mask. Max 4 character is number
};
export const CALENDAR_BOOKING_DOMAIN = [
    'aura-mico.jp',
    'reserbo.jp',
    'tnextline.mico-cloud.jp',
    'bona.mico-cloud.jp',
];

export const CREDIT_CARD_PAYMENT_MONTH = 12;

export const EC_GMO_CODE_NUMBER_CREDIT_CARD = [
    101,
    102,
    551
];

export const EC_GMO_CODE_EXPIRATION_DATE_CREDIT_CARD = [
    111,
    112,
    113
];

export const EC_GMO_CODE_SECURITY_CODE_CREDIT_CARD = [
    121,
    122
];

export const EC_GMO_ERROR_OTHER_CREDIT_CARD = [
    100,
    110,
    131,
    132,
    501,
    502,
    511,
    512,
    521,
    522,
    531,
    541,
    552,
    553
];


export const PROCESS_NAME_MAX_LENGTH = 18;
export const PROCESS_NAME_SPLIT_INDEX = {
    'start': 0,
    'end': 15
};
export const PROCESS_NAME_DOT_STRING = '...';
export const MICROSECOND_TO_MINUTE = 1000*60;
export const LIMIT_CHANGE_EMAIL_MY_CALENDAR = 3;

export const RICH_MENU_PREVIEW_IMAGE_HALF_SIZE = 843;

export const EXTENSION_ATTACH_FILE = [
    // text file
    'txt',
    'asc',
    'sjis',

    // image
    'gif',
    'jpg',
    'jpeg',
    'jpe',
    'jfif',
    'png',
    'bmp',
    'dib',
    'rle',
    'ico',
    'ai',
    'art',
    'cam',
    'cdr',
    'cgm',
    'cmp',
    'dpx',
    'fal',
    'q0',
    'fpx',
    'j6i',
    'mac',
    'mag',
    'maki',
    'mng',
    'pcd',
    'pct',
    'pic',
    'pict',
    'pcx',
    'pmp',
    'pnm',
    'psd',
    'ras',
    'sj1',
    'tif',
    'tiff',
    'nsk',
    'tga',
    'wmf',
    'wpg',
    'xbm',
    'xpm',

    // video

    // audio
    'mp3',
    'mid',
    'midi',
    'wav',
    'aif',
    'aiff',
    'aifc',
    'au',
    'snd',

    // multimedia
    'mov',
    'qt',
    'mpg',
    'mpeg',
    'wm',
    'wma',
    'wmv',
    'asf',
    'wax',
    'wvx',
    'asx',
    'ra',
    'rv',
    'rm',
    'ram',
    'rmm',
    'rpm',
    'swf',
    'avi',
    'dvr-ms',
    'scr',
    'smi',
    'smil',
    'vdo',
    'vrml',
    'wrl',

    // compression
    'lzh',
    'zip',
    'cab',
    'tar',
    'gz ',
    'tgz',
    'tar.gz',
    'hqx',
    'sit',
    'Z',
    'uu',
    'bin',

    // application
    'pdf',
    'doc',
    'xls',
    'ppt',
    'pps',
    'dcr',
    'dir',
    'dxr',
    'dwt',
    'fla',
    'jxw',
    'ppd',
    'ps',
    'eps',
    'ai',
    'rtf',
    'wri',

    // other
    'csv',

    //Microsoft file
    'xlsx',
    'docx',
    'pptx',
];

export const AUTO_COMPLETE_TYPE = {
    SCHOOL: 1,
    FACULTY: 2,
    DEPARTMENT: 3,
    RATING_POINT_SCHOOL: 4,
};

export const LINE_ICON_DEFAULT_IMAGES = {
    id: null,
    name: '－',
    icon_url: '/img/avatar.png',
};

export const SORT_DENIED_WORD_OPTIONS = {
    CREATED: 'created',
    SETTING_TIME_ASC: 'setting_time_asc',
    SETTING_TIME_DESC: 'setting_time_desc'
};

export const REPORT_POINT_SETTING = {
    REPORT_POINT_TITLE: '内申点',
    REPORT_POINT_TITLE2: '入試科目の自己採点',
    REPORT_POINT_QUESTION_INDEX: 1,
    REPORT_POINT_QUESTION_INDEX2: 3,
    MAX_REPORT_POINT_TITLE: '/45',
    MAX_REPORT_POINT_TITLE2: '/100',
};

export const QUESTION_RULE_KEY = {
    NONE: 0,
    DATE: 1,
    KANA: 2,
    EMAIL: 3,
    TEL: 4,
    INTEGER: 5,
    TIME: 6,
    POSTAL_CODE: 7,
    EXAM_SCORE: 8,
    REPORT_EXAM_SCORE: 9,
};

export const FURIGANA_NAME = 'フリガナ';

export const PAGINATION = {
    RECORD_TEXT: '件',
    PREV_TEXT: '<',
    NEXT_TEXT: '>',
    LAST_BUTTON_TEXT: '最後へ',
    FIRST_BUTTON_TEXT: '最初へ',
};
export const PAGINATION_OPTIONS = [];
export const DUPLICATE_TYPES = {
    PROFILE_SETTING: {
        label: 'プロフィール',
        type: 'profile_setting'
    },
    STATUS: {
        label: 'ステータス',
        type: 'status'
    },
    WORD_SETTINGS: {
        label: 'ワード設定',
        type: 'word_settings'
    },
    TAG: {
        label: 'タグ',
        type: 'tag'
    },
    TEMPLATE: {
        label: 'テンプレート',
        type: 'template'
    },
    SCENARIO: {
        label: 'シナリオ',
        type: 'scenario'
    },
    AUTO_RESPONSE: {
        label: '自動応答',
        type: 'auto_response'
    },
    QR_CODE: {
        label: 'QRコード',
        type: 'qr_code'
    }
};
export const REFRESH_DUPLICATION_PROGRESS_TIME = 5000;
export const STATUS_DUPLICATION_DONE = 2;
export const STATUS_DUPLICATING = 1;
export const REFRESH_UPDATE_STATUS_DUPLICATE_TIME = 30000;

export const NOTIFICATION = {
    SETTING_1: 0,
    SETTING_2: 1,
    SETTING_3: 2,
};


export const OR_CONDITION_OFF = 0;
export const OR_CONDITION_ON = 1;

export const DUPLICATE_TEMPLATE_FOLDER_STATUS = {
    DEFAULT: 0,
    PROCESSING: 1,
    FAIL: 2,
};

export const GENERAL_TAG = {
    EDIT_NAME: 1,
    EDIT_SETTING: 2,
    RE_CREATE: 3,
    DELETE: 4
};

export const DIVIDE_TAG = {
    EDIT_NAME: 5,
    EDIT_SETTING: 6,
    DELETE: 7,
    CREATE: 8,
};

export const TOKIO_MARINE_SYNCHRONIZATION_FOLDER_NAME = '【会社提供】';
